import React from 'react';

import AgGridDatepickerTag4Editor, { HandleChangeDate, IAgGridDatepickerTag4EditorProps }
  from '@/components/common/TableGrid/CustomComponents/AgGridDatepicker/AgGridDatepickerTag4Editor';

interface ILineStartDateEditorProps extends IAgGridDatepickerTag4EditorProps {
}

function LineStartDateEditor(
  props: ILineStartDateEditorProps,
) {
  const { handleChangeDate, ...restProps } = props;

  const handleCustomChangeDate: HandleChangeDate = (selectedDate, applyChanges) => {
    applyChanges(selectedDate);
  };

  return (
    <>
      <AgGridDatepickerTag4Editor
        handleChangeDate={handleCustomChangeDate}
        {...restProps}
      />
    </>
  );
}

export default LineStartDateEditor;
